import { TDateField, TImageField, TLinkField, TStringField, VideoSitecoreField } from '../../../../types/types';
import { isEmptyObject } from '../../../../utils/checkEmptyObject';
import { getCanUseDate } from '../../../../utils/eventsListings.utils';
import { TSocialMediaBarProps } from '../../../@shared/socialMediaBar/types/socialMediaBar.types';
import { TSaveCalendarEventProps } from '../../saveCalendarEvent/types/saveEvent.types';
import { TEventDetailFields, TEventDetailProps } from '../types/eventDetail.types';

export class EventDetailModel {
  private readonly fields?: TEventDetailFields;

  constructor(props: TEventDetailProps) {
    this.fields = props.fields;
  }

  get title(): TStringField | undefined {
    return this.fields?.title;
  }  
  
  get time(): TStringField | undefined {
    return this.fields?.time;
  }

  get location(): TStringField | undefined {
    return this.fields?.location;
  }

  get startDate(): TDateField {
    return this.fields?.startDate || {};
  }

  get canShowStartDate(): boolean {
    return getCanUseDate(this.fields?.startDate?.value);
  }

  get endDate(): TDateField {
    return this.fields?.endDate || {};
  }

  get canShowEndDate(): boolean {
    return getCanUseDate(this.fields?.endDate?.value);
  }

  get calendarDetails(): TSaveCalendarEventProps['calendarDetails'] {
    return this.fields?.calendarDetails || [];
  }

  get desktopImage(): TImageField | undefined {
    return this.fields?.image;
  }

  get mobileImage(): TImageField | undefined {
    return this.fields?.mobileImage;
  }

  get showVideo(): boolean {
    return !!this.fields?.useVideo?.value && !!this.fields?.video?.value?.href;
  }

  get video(): VideoSitecoreField {
    return this.fields?.video ?? { value: {} };
  }

  get mediaExists(): boolean {
    return !!(this.showVideo || this.fields?.image?.value?.src || this.fields?.mobileImage?.value?.src);
  }

  get detailedDescription(): TStringField | undefined {
    return this.fields?.detailedDescription;
  }

  get primaryCta(): TLinkField | undefined {
    return this.fields?.primaryCta;
  }

  get showPrimaryCta(): boolean {
    return !!(this.primaryCta?.value?.text && this.primaryCta?.value?.href);
  }

  get secondaryCta(): TLinkField | undefined {
    return this.fields?.secondaryCta;
  }

  get showSecondaryCta(): boolean {
    return !!(this.secondaryCta?.value?.text && this.secondaryCta?.value?.href);
  }

  get showCtaWrapper(): boolean {
    return this.showPrimaryCta || this.showSecondaryCta;
  }

  get socialMediaBarProps(): TSocialMediaBarProps | undefined {
    return isEmptyObject(this.fields?.socialMediaBar) ? undefined : this.fields?.socialMediaBar;
  }

  get isUnreleased(): boolean {
    return !!this.fields?.isComponentUnreleased;
  }

}
